var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query"},[_c('MyHeader',{attrs:{"msg":"二维码追溯结果"}}),_c('MyContent',{attrs:{"dataRes":_vm.dataRes}}),_c('MyFooter',{attrs:{"dataRes":_vm.dataRes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }